<template>
  <transition name="fade">
    <v-container class="CreaPriceBlock">
      <v-tooltip open-delay="500" color="rgba(var(--removeObject-rgb),.9)" bottom>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" small depressed dark fab @click="removeComponent" class="delete_button">
            <v-icon>mdi-trash-can-outline</v-icon>
          </v-btn>
        </template>
        <span>Supprimer</span>
      </v-tooltip>
      <div class="d-inline-block">
        <div class="div-flex-space-between">
          <v-text-field
            color="rgb(var(--new-media-rgb))"
            append-icon="mdi-currency-eur"
            label="Prix"
            v-model="price"
            type="number"
            @change="addPrice"
            style="margin-right:20px;max-width:100px;"
          ></v-text-field>
          <v-textarea
            color="rgb(var(--new-media-rgb))"
            label="Texte libre"
            v-model="text"
            rows="1"
            @change="addPrice"
            :rules="[rules.counter]"
            maxlength="40"
          ></v-textarea>
        </div>
        <div class="custom-center div-flex-space-between">
          <v-btn-toggle v-model="fontStyle" @change="addPrice" group multiple color="rgb(var(--new-media-rgb))">
          <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" value="bold" style="border-radius:50em"><span class="headline font-weight-black">G</span></v-btn>
            </template>
            <span>Gras</span>
          </v-tooltip>
          <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" value="underline" style="border-radius:50em;"><span class="headline font-weight-medium underline" style="text-decoration:underline">S</span></v-btn>
            </template>
            <span>Souligné</span>
          </v-tooltip>
          <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
            <template v-slot:activator="{ on }">
              <v-btn v-on="on" value="line-through" style="border-radius:50em;"><span class="headline font-weight-medium line-through" style="text-decoration:line-through">B</span></v-btn>
            </template>
            <span>Barré</span>
          </v-tooltip>
          </v-btn-toggle>
          <v-menu :close-on-content-click="false" offset-y :offsetOverflow="true" left>
            <template v-slot:activator="{ on: menu }">
              <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn height="36px" dark width="36px" style="box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.3)!important;" fab depressed small v-on="{...tooltip, ...menu}" :color="chosenColor" @click="setColorPickerVisibility">
                    <v-icon class="pt-1">mdi-format-color-fill</v-icon>
                  </v-btn>
                </template>
                <span>Couleur</span>
              </v-tooltip>
            </template>
            <v-color-picker @change="addPrice" v-model="chosenColor" canvas-height="100" width="250" mode="hexa" :hide-mode-switch="hideSwitch" class="d-inline-block" ></v-color-picker>
          </v-menu>
          <div>
            <v-select return-object dense outlined rounded single-line hide-details class="custom-select" color="new_media" item-color="new_media" :menu-props="{offsetY: true, offsetOverflow: true, maxHeight: 300}" append-icon="mdi-chevron-down" style="width:140px;" item-value="text" label="Arial" :items="fonts" v-model="chosenFont" @change="addPrice">
              <template slot="item" slot-scope="data">
                <span :style="`font-family: ${data.item.fontFamily}`">{{ data.item.text }}</span>
              </template>
            </v-select>
          </div>
        </div>
        <div class="custom-center" style="border-radius:0px 0px 10px 10px;padding:10px;margin:0 -16px -10px -16px;display: flex; justify-content: center; background-color:rgba(0,0,0,0.07);">
          <div style="margin-right:16px;">
            <v-select dense outlined rounded single-line hide-details color="new_media" background-color="var(--v-contrast-base)" return-object class="custom-select" item-color="new_media" :menu-props="{offsetY: true, offsetOverflow: true, maxHeight: 300}" append-icon="mdi-chevron-down" style="width:220px;" label="Sans fond" :items="shapes" v-model="chosenShape" @change="addPrice">
              <template slot="item" slot-scope="data">
                <span>{{ data.item.text }}</span>
              </template>
            </v-select>
          </div>
          <v-menu :close-on-content-click="false" offset-y :offsetOverflow="true" left>
            <template v-slot:activator="{ on: menu }">
              <v-tooltip color="rgba(var(--new-media-rgb),1)" bottom>
                <template v-slot:activator="{ on: tooltip }">
                  <v-btn height="36px" dark width="36px" style="box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.3)!important;" fab depressed small v-on="{...tooltip, ...menu}" :color="shapeColor" @click="setColorPickerVisibility">
                    <v-icon class="pt-1">mdi-format-color-fill</v-icon>
                  </v-btn>
                </template>
                <span>Couleur</span>
              </v-tooltip>
            </template>
            <v-color-picker @change="addPrice" v-model="shapeColor" canvas-height="100" width="250" mode="hexa" :hide-mode-switch="hideSwitch" class="d-inline-block" ></v-color-picker>
          </v-menu>
        </div>
      </div>
    </v-container>
  </transition>
</template>

<script>
import Konva from 'konva'
export default {
  props: ['data'],
  data () {
    return {
      price: '',
      text: '',
      hideInputs: true,
      chosenColor: '#16C979FF',
      shapeColor: '#fff',
      colorVisible: false,
      shapeColorVisible: false,
      hideSwitch: true,
      selectClass: this.$store.state.theme === 'dark' ? 'darkSelect' : 'lightSelect',
      chosenFont: 'Arial',
      chosenShape: {id: 2, name: 'nothing', text: 'Sans fond'},
       fonts: [
        {text: 'Arial', fontFamily: 'arial'},
        {text: 'Aller', fontFamily: 'aller'},
        {text: 'Arvo', fontFamily: 'arvo'},
        {text: 'Chancery', fontFamily: 'chancery'},
        {text: 'Desyrel', fontFamily: 'desyrel'},
        {text: 'Drunken', fontFamily: 'drunkenSerif'},
        {text: 'Futura', fontFamily: 'futura'},
        {text: 'Gothic', fontFamily: 'gothic'},
        {text: 'Komika', fontFamily: 'komika'},
        {text: 'Stencil', fontFamily: 'stencil'},
        {text: 'Sciences', fontFamily: 'sciences'}
      ],
      shapes: [
        {id: 2, name: 'nothing', text: 'Sans fond'},
        {id: 0, name: 'rectangle', text: 'Avec fond rectangle'},
        {id: 1, name: 'circle', text: 'Avec fond arrondi'}    
      ],
      id: this.data,
      fontStyle: [],
      rules: {
        counter: value => value.length <= 39 || this.$i18n.t('rules.price-max-char'),
      }
    }
  },
  methods: {
    setColorPickerVisibility () {
      this.colorVisible = !this.colorVisible
    },
    setShapeColorPickerVisibility () {
      this.shapeColorVisible = !this.shapeColorVisible
    },
    addPrice () {
      var validPrice = this.price
      if (this.price) {
        validPrice = validPrice * 1.0
        validPrice = validPrice.toFixed(2)
        this.price = validPrice       
        validPrice = validPrice.toString().replace(/\./g, ',')
        if (validPrice.endsWith('00')) {
          validPrice = validPrice.substring(0, validPrice.length-3)
        }
      }
      
      var price =  validPrice ? validPrice + ' € ' : null
      
      if (price && (this.text === null || this.text === '')) {
        if (this.chosenShape.id === 0) {
          var rectanglePrix = new Konva.Rect({
            x: 0,
            y: 0,
            fill: this.shapeColor,
            stroke: this.chosenColor,
            strokeWidth: 2
          })
          let konvaText = new Konva.Text({
            x: 7,
            fontSize: 24,
            fontFamily: this.chosenFont.fontFamily,
            fill: this.chosenColor,
            text: price,
            id: this.id
          })

          if (this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('underline line-through')
          } else if (this.fontStyle.includes('underline') && !this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('underline')
          } else if (!this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('line-through')
          }

          if (this.fontStyle.includes('bold')) {
            konvaText.fontStyle('bold')
          }
          rectanglePrix.height(24 * 1.5)
          konvaText.y((0.25 * 24) + Math.round(24 / 10))
          rectanglePrix.width(konvaText.getWidth() + 14)
          this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPrice(konvaText, rectanglePrix, true)
        } else if (this.chosenShape.id === 1) {
          var cerclePrix = new Konva.Ellipse({
            fill: this.shapeColor,
            stroke: this.chosenColor,
            strokeWidth: 2
          })

          let konvaText = new Konva.Text({
            x: 7,
            fontSize: 24,
            fontFamily: this.chosenFont.fontFamily,
            fill: this.chosenColor,
            text: price,
            id: this.id
          })

          if (this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('underline line-through')
          } else if (this.fontStyle.includes('underline') && !this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('underline')
          } else if (!this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('line-through')
          }
          if (this.fontStyle.includes('bold')) {
            konvaText.fontStyle('bold')
          }
          cerclePrix.radius({
            x: konvaText.getWidth() / 2 + 5,
            y: konvaText.getWidth() / 2 + 5
          })

          konvaText.x(5)
          konvaText.y(konvaText.getWidth() / 2 - 5)
          cerclePrix.x(5 + konvaText.getWidth() / 2)
          cerclePrix.y(5 + konvaText.getWidth() / 2)
          this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPrice(konvaText, cerclePrix, false)
        } else {
          let konvaText = new Konva.Text({
            draggable: true,
            x: 10,
            y: 10,
            fontSize: 24,
            fontFamily: this.chosenFont.fontFamily,
            fill: this.chosenColor,
            text: price,
            id: this.id
          })

          if (this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('underline line-through')
          } else if (this.fontStyle.includes('underline') && !this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('underline')
          } else if (!this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
            konvaText.textDecoration('line-through')
          }
          if (this.fontStyle.includes('bold')) {
            konvaText.fontStyle('bold')
          }
          this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPrice(konvaText, null, false)
        }
      } else if (price && this.text !== '') {
        var konvaFrame = new Konva.Rect({
          x: 0,
          y: 0,
          height: 48,
          fill: this.shapeColor
        })
        if (this.chosenShape.id === 1) {
          konvaFrame.cornerRadius(24)
        }
        var konvaPrix = new Konva.Text({
          x:7,
          fontSize: 32,
          fontFamily: this.chosenFont.fontFamily,
          fill: this.chosenColor,
          text: price,
          id: this.id
        })
        konvaPrix.y((0.25 * 32) + Math.round(32 / 10))
        if (this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
          konvaPrix.textDecoration('underline line-through')
        } else if (this.fontStyle.includes('underline') && !this.fontStyle.includes('line-through')) {
          konvaPrix.textDecoration('underline')
        } else if (!this.fontStyle.includes('underline') && this.fontStyle.includes('line-through')) {
          konvaPrix.textDecoration('line-through')
        }
        if (this.fontStyle.includes('bold')) {
          konvaPrix.fontStyle('bold')
        }
        let lineX = 10 + konvaPrix.width()
        let lineY = 8
        var line = new Konva.Line({
          x: lineX,
          y: lineY,
          points: [0, 0, 0, 32],
          stroke: this.chosenColor,
          strokeWidth: 2
        })   
     
        if (this.text.length <= 20) {
          var textX = 18 + konvaPrix.width()
          var konvaText = new Konva.Text({
            x: textX,
            y: 12,
            fontSize: 24,
            fontFamily: this.chosenFont.fontFamily,
            fill: this.chosenColor,
            text: this.text
          })
          konvaFrame.width(textX + konvaText.width() + 12)
          var group = new Konva.Group({
            id: 'priceBlock' + this.id,
            x: 0,
            y: 0,
            width: konvaFrame.width(),
            height: konvaFrame.height(),
            draggable: true,
            listening: true
          })        
          group.add(konvaFrame)
          group.add(konvaPrix)
          group.add(line)
          group.add(konvaText)
          this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPriceWithText(group, this.id)
        } else {
          var words = this.text.split(' ')
          var half = Math.floor(this.text.length / 2)
          // - 1 Pour compenser l'espace initial
          var line1Length = -1
          var line1Text = ''
          var line2Text = ''
          for (let i = 0 ; i < words.length; i++) {
            line1Length += words[i].length + 1
            if (line1Length < half) {
              line1Text += words[i] + ' '
            } else {
              line2Text += words[i] + ' '
            }
          }
          var textX = 18 + konvaPrix.width()
          var konvaText1 = new Konva.Text({
            x: textX,
            y: 7,
            fontSize: 16,
            fontFamily: this.chosenFont.fontFamily,
            fill: this.chosenColor,
            text: line1Text
          })
          var konvaText2 = new Konva.Text({
            x: textX,
            y: 25,
            fontSize: 16,
            fontFamily: this.chosenFont.fontFamily,
            fill: this.chosenColor,
            text: line2Text
          })
          konvaFrame.width(textX + konvaText2.width() + 12)
          var group = new Konva.Group({
            id: 'priceBlock' + this.id,
            x: 0,
            y: 0,
            width: konvaFrame.width(),
            height: konvaFrame.height(),
            draggable: true,
            listening: true
          })        
          group.add(konvaFrame)
          group.add(konvaPrix)
          group.add(line)
          group.add(konvaText1)
          group.add(konvaText2)
          this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPriceWithText(group, this.id)
        }
      } else {
        this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPriceWithText(null, this.id)
      }
    },
    removeComponent () {
      let konvaPrice = new Konva.Text({
        id: this.id,
        draggable: true,
        x: 10,
        y: 10,
        fontSize: 24,
        fontFamily: this.chosenFont.fontFamily,
        fill: this.chosenColor,
        text: ''
      })
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.addPrice(konvaPrice, null, null)
      this.$parent.$parent.$parent.$parent.$parent.$parent.$parent.removePrice(this.id)
    }
  },
  watch: {
    chosenColor: function () {
      if (this.price) {
        this.addPrice()
      }
    },
    shapeColor: function () {
      if (this.price) {
        this.addPrice()
      }
    },
    text: function () {
      if (this.text === null || this.text === '') {
        this.shapes = [
          {id: 2, name: 'nothing', text: 'Sans fond'},
          {id: 0, name: 'rectangle', text: 'Avec fond rectangle'},
          {id: 1, name: 'circle', text: 'Avec fond arrondi'}    
        ]
        this.chosenShape = {id: 2, name: 'nothing', text: 'Sans fond'}
      } else {
        this.shapes = [
          {id: 0, name: 'rectangle', text: 'Avec fond rectangle'},
          {id: 1, name: 'circle', text: 'Avec fond arrondi'}    
        ]
        this.chosenShape = {id: 1, name: 'circle', text: 'Avec fond arrondi'}
      }
    }
  }
}
</script>

<style scoped>

select{
  -webkit-appearance: listbox;
  font-size: 20px;
  padding-left: 10px;
  min-width: 150px;
  height: 42px;
  border-style: solid;
  border-color: black;
  border-color: 1px;
  border-radius: 21px;
}

option{
  font-size: 20px;
}

.darkSelect{
  width: 130px;
  background-color: inherit;
  color: white;
  border: 1px solid white;
}

.darkSelect option{
  background-color: inherit;
}

.div-align-top *{
  vertical-align: top;
}

.v--modal-box{
  overflow: auto;
  max-height: 800px
}

.drunkenSerif {
font-family: drunkenSerif;
}

.desyrel {
font-family: desyrel;
}

.arial {
font-family: arial;
}

.arvo {
font-family: arvo;
}

.aller {
font-family: aller;
}

.stencil {
font-family: stencil;
}

.komika {
font-family: komika;
}

.sciences {
font-family: sciences;
}

.chancery {
font-family: chancery;
}

.gothic {
font-family: gothic;
}

.futura {
font-family: futura;
}

</style>
